export default "__VITE_ASSET__d4402e6b__"